/**
 * Scroll helpers for config-driven forms — used after failed client/server validation.
 */

export function getFirstErrorFieldName(errors = {}, fieldOrder = []) {
  const errorKeys = Object.keys(errors).filter((key) => Boolean(errors[key]));
  if (!errorKeys.length) {
    return null;
  }

  const errorSet = new Set(errorKeys);

  for (const name of fieldOrder) {
    if (errorSet.has(name)) {
      return name;
    }
  }

  return errorKeys[0] ?? null;
}

export function scrollToFormField(fieldName, options = {}) {
  if (!fieldName || typeof document === 'undefined') {
    return false;
  }

  const selector = `[data-form-field="${CSS.escape(fieldName)}"]`;
  const element = document.querySelector(selector);
  if (!element) {
    return false;
  }

  element.scrollIntoView({
    behavior: options.behavior ?? 'smooth',
    block: options.block ?? 'center',
  });

  if (options.focus !== false) {
    const focusable = element.querySelector(
      'input:not([type="hidden"]), textarea, select, button, [tabindex]:not([tabindex="-1"])'
    );
    focusable?.focus({ preventScroll: true });
  }

  return true;
}

export function scrollToFirstFormError(errors = {}, fieldOrder = [], options = {}) {
  const fieldName = getFirstErrorFieldName(errors, fieldOrder);
  if (!fieldName) {
    return null;
  }

  scrollToFormField(fieldName, options);
  return fieldName;
}
